import angular from 'angular';

import {
  downgradeComponent,
  downgradeInjectable
} from '@angular/upgrade/static';

import { CustomerMessagesNotificationsComponent } from './customer-messages.notifications.component';
import { CustomerMessagesService }                from './customer-messages.service';

angular.module('app-lite.messages.customer-messages', [])
.directive('worCustomerMessagesNotifications', downgradeComponent({ component: CustomerMessagesNotificationsComponent }))
.service('customerMessagesApi', downgradeInjectable( CustomerMessagesService ));